<template lang="pug">
  .dateRow.text-center
    .dateRow__dataBox.badge-pill.d-inline-block
      small {{ filterWeek(this.timeData) }}
</template>

<script>
export default {
  name: 'TitleDateComponent',
  props: {
    timeData: {
      type: String,
      required: true
    }
  }
};
</script>

<style>

</style>
